import type { CSSProperties, ReactNode } from 'react'

type Props = {
  type?: 'button' | 'submit'
  variant?: 'primary' | 'outline'
  /** Shows spinner and disables the control. */
  loading?: boolean
  /** Label while loading (defaults to `children`). */
  loadingLabel?: ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
  style?: CSSProperties
  children: ReactNode
}

/**
 * Shared primary / outline button using existing download-screen styles (spinner, disabled, contrast).
 * One place to tune loading + disabled appearance for hybrid forms.
 */
export function AppButton({
  type = 'button',
  variant = 'primary',
  loading = false,
  loadingLabel,
  disabled = false,
  onClick,
  className = '',
  style,
  children,
}: Props) {
  const busy = loading || disabled
  const classes = [
    'app-download-btn',
    variant === 'primary' ? 'primary' : '',
    variant === 'outline' ? 'subtle' : '',
    loading ? 'app-download-btn-loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button type={type} className={classes} style={style} disabled={busy} onClick={onClick}>
      {loading ? (
        <>
          <span className="app-download-btn-spinner" aria-hidden />
          {loadingLabel ?? children}
        </>
      ) : (
        children
      )}
    </button>
  )
}
